import * as React from "react";
import "./PickerTooltip.css";

// =============================================================================
// PickerTooltip Component
// Shared tooltip for date/time pickers showing resolved values
// =============================================================================

export interface PickerTooltipProps {
  /** Tooltip content - newline separated, with "label: value" format */
  content: string | undefined;
  /** Position relative to input - top (default) or bottom */
  position?: "top" | "bottom";
  /** Additional CSS class */
  className?: string;
}

export const PickerTooltip = React.memo(function PickerTooltip({
  content,
  position = "top",
  className,
}: PickerTooltipProps) {
  if (!content) return null;

  const positionClass = position === "bottom" ? "picker-tooltip--bottom" : "";

  return (
    <div className={`picker-tooltip ${positionClass} ${className || ""}`} role="tooltip">
      {content.split("\n").map((line, i) => {
        if (line === "") {
          return <div key={i} className="picker-tooltip__spacer" />;
        }
        const colonIndex = line.indexOf(":");
        if (colonIndex === -1) {
          return (
            <div key={i} className="picker-tooltip__line picker-tooltip__line--full">
              {line}
            </div>
          );
        }
        const label = line.slice(0, colonIndex);
        const value = line.slice(colonIndex + 1).trim();
        return (
          <div key={i} className="picker-tooltip__line">
            <span className="picker-tooltip__label">{label}:</span>
            <span className="picker-tooltip__value">{value}</span>
          </div>
        );
      })}
    </div>
  );
});
